import { BaseEnum } from "services/enums/baseEnum";

const listsEnum: Array<FormType> = [];

export class FormType extends BaseEnum {
  static PROBATIONARY_REVIEW_EMPLOYEE = new FormType(1, 'PROBATIONARY_REVIEW_EMPLOYEE', 'PROBATIONARY_REVIEW_EMPLOYEE');
  static PROBATIONARY_REVIEW_MANAGER = new FormType(2, 'PROBATIONARY_REVIEW_MANAGER', 'PROBATIONARY_REVIEW_MANAGER');
  static WORK_CHECK = new FormType(3, 'WORK_CHECK', 'WORK_CHECK');
  static RESEARCH = new FormType(4, 'RESEARCH', 'RESEARCH');
  static ETHICS_CHANNEL = new FormType(5, 'ETHICS_CHANNEL', 'ETHICS_CHANNEL');
  static RECRUITMENT_NPS = new FormType(6, 'RECRUITMENT_NPS', 'RECRUITMENT_NPS');

  constructor(public id: number, public value: string, public label: string) {
    super(id, value, label)
    listsEnum.push(this);
  }

  public static buildListEnum(): Array<BaseEnum> {
    return listsEnum;
  }
}